import React from 'react';
import { Button } from '@mui/material';

const FormButton = ({
  children,
  variant = 'contained',
  type = 'button',
  onClick,
  disabled = false,
  loading = false,
  color = 'primary',
  size = 'medium',
  fullWidth = false,
  startIcon,
  endIcon,
  sx = {},
  ...props
}) => {
  const getButtonStyles = () => {
    const baseStyles = {
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 600,
      textTransform: 'none',
      borderRadius: '12px',
      boxShadow: '0px 20px 80px #00000011',
      opacity: 1,
      '&:hover': {
        boxShadow: '0px 20px 80px #00000022',
      },
      '&:disabled': {
        opacity: 0.6,
      },
    };

    if (variant === 'contained') {
      return {
        ...baseStyles,
        backgroundColor: color === 'primary' ? '#027BC6' : color === 'success' ? '#0AD69F' : color === 'error' ? '#EF456E' : '#027BC6',
        color: '#ffffff',
        '&:hover': {
          ...baseStyles['&:hover'],
          backgroundColor: color === 'primary' ? '#025a9c' : color === 'success' ? '#08B894' : color === 'error' ? '#D63A5F' : '#025a9c',
        },
      };
    }

    if (variant === 'outlined') {
      return {
        ...baseStyles,
        backgroundColor: 'transparent',
        border: `2px solid ${color === 'primary' ? '#027BC6' : color === 'success' ? '#0AD69F' : color === 'error' ? '#EF456E' : '#027BC6'}`,
        color: color === 'primary' ? '#027BC6' : color === 'success' ? '#0AD69F' : color === 'error' ? '#EF456E' : '#027BC6',
        '&:hover': {
          ...baseStyles['&:hover'],
          backgroundColor: color === 'primary' ? '#F0F8FF' : color === 'success' ? '#F0FFF4' : color === 'error' ? '#FFF5F5' : '#F0F8FF',
        },
      };
    }

    return baseStyles;
  };

  return (
    <Button
      variant={variant}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      size={size}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        ...getButtonStyles(),
        ...sx,
      }}
      {...props}
    >
      {loading ? 'Chargement...' : children}
    </Button>
  );
};

export default FormButton;
